
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iYusr", function(module, exports) {
const $03909aa8b5a3673a$var$API = 'https://rnd.mypubs.ru/api.php';
const $03909aa8b5a3673a$var$IS_DEBUG = false;
function $03909aa8b5a3673a$var$getRating(url, container) {
    $.post($03909aa8b5a3673a$var$API, {
        url: url,
        cmd: "rating"
    }).done(function(data) {
        if ($03909aa8b5a3673a$var$IS_DEBUG) console.log(data);
        if (data.length === 0) $03909aa8b5a3673a$var$addRating(0, 0, container);
        else {
            var info = JSON.parse(data);
            $03909aa8b5a3673a$var$addRating(info.sum, info.count, container);
        }
    }).fail(function(data) {
        if ($03909aa8b5a3673a$var$IS_DEBUG) console.error(data);
        $03909aa8b5a3673a$var$addRating(0, 0, container);
    });
}
function $03909aa8b5a3673a$var$addRating(sum, count, item) {
    if (count === 0 || sum === undefined || sum === 0) {
        $(item).html(`${$03909aa8b5a3673a$var$stars(0)}`);
        $(item).attr('value', '-1');
        return;
    }
    var avg = sum / count;
    $(item).html(`${$03909aa8b5a3673a$var$stars(avg)} ${avg.toFixed(1)}`);
    $(item).attr('value', avg.toFixed(1));
}
function $03909aa8b5a3673a$var$getBarStatus(container) {
    const worklist = container.data('worklist').split(';;;').filter(Boolean);
    const days = [
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431",
        "\u0432\u0441"
    ];
    const now = new Date();
    const currentDay = (now.getDay() + 6) % 7;
    const currentMinutes = currentDay * 1440 + now.getHours() * 60 + now.getMinutes();
    let isOpen = false;
    let closesInMinutes = Infinity;
    worklist.forEach((item)=>{
        const [dayRange, timeRange] = item.split('|');
        const [openTime, closeTime] = timeRange.split(/\s*[–-]\s*/).map((time)=>{
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
        });
        const range = dayRange.toLowerCase().split(/\s*[–-]\s*/);
        const startDay = days.indexOf(range[0]);
        const endDay = days.indexOf(range[1] || range[0]);
        const dayCount = (endDay - startDay + 7) % 7 + 1;
        for(let dayOffset = 0; dayOffset < dayCount; dayOffset += 1){
            const openingDay = (startDay + dayOffset) % 7;
            const openingMinutes = openingDay * 1440 + openTime;
            const closingMinutes = openingMinutes + (closeTime <= openTime ? 1440 - openTime + closeTime : closeTime - openTime);
            if (currentMinutes >= openingMinutes && currentMinutes < closingMinutes) {
                isOpen = true;
                closesInMinutes = Math.min(closesInMinutes, closingMinutes - currentMinutes);
            }
        }
    });
    const isClosingSoon = isOpen && closesInMinutes <= 60;
    return {
        isClosingSoon: isClosingSoon,
        isOpen: isOpen
    };
}
function $03909aa8b5a3673a$var$stars(rating) {
    var value = Math.min(5, Math.max(0, Number(rating) || 0));
    var full = Math.floor(value);
    var half = value - full >= 0.5 ? 1 : 0;
    var empty = 5 - full - half;
    return '<i class="fa-solid fa-star"></i>'.repeat(full) + '<i class="fa-solid fa-star-half-stroke"></i>'.repeat(half) + '<i class="fa-regular fa-star"></i>'.repeat(empty);
}
function $03909aa8b5a3673a$var$setMaps() {
    var list = $('article');
    list.each(function(index, item) {
        var name = $(item).find('.bar-title a').text();
        var icon = $(item).find('.map-marker').data('src');
        var location = $(item).find('.map-location').val();
        if (location) {
            const frame = $(item).find('.map-frame');
            const [lat, lng] = location.split(',').map(Number);
            const map = L.map(frame[0]).setView([
                lat,
                lng
            ], 15);
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; OSM'
            }).addTo(map);
            const marker = icon ? L.icon({
                iconUrl: icon,
                iconSize: [
                    40,
                    40
                ],
                iconAnchor: [
                    20,
                    40
                ],
                popupAnchor: [
                    0,
                    -40
                ]
            }) : new L.Icon.Default();
            L.marker([
                lat,
                lng
            ], {
                icon: marker
            }).addTo(map).bindPopup(name);
            $(item).data('leaflet-map', map);
            $(item).find('.leaflet-control-attribution a, .leaflet-control-attribution span').hide();
        }
    });
    $03909aa8b5a3673a$var$refreshMaps();
}
function $03909aa8b5a3673a$var$refreshMaps() {
    $('article:visible').each(function() {
        const map = $(this).data('leaflet-map');
        if (map) setTimeout(()=>{
            map.invalidateSize();
        }, 0);
    });
}
function $03909aa8b5a3673a$var$setRatings() {
    var list = $('article');
    list.each(function(index, item) {
        var container = $(item).find('.bar-rating');
        var url = $(item).find('.bar-title a').attr('href');
        if (url) $03909aa8b5a3673a$var$getRating(url, container);
    });
}
function $03909aa8b5a3673a$var$setStatuses() {
    var list = $('article');
    list.each(function(index, item) {
        var status = $(item).find('.bar-hours');
        if (status.length > 0) {
            var info = $03909aa8b5a3673a$var$getBarStatus(status);
            $(status).html(info.isClosingSoon ? "\u0421\u043A\u043E\u0440\u043E \u0437\u0430\u043A\u0440\u043E\u0435\u0442\u0441\u044F" : info.isOpen ? "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u0441\u0435\u0439\u0447\u0430\u0441" : "\u0417\u0430\u043A\u0440\u044B\u0442\u043E");
        }
    });
}
window.mypubs = window.mypubs || {};
Object.assign(window.mypubs, {
    API: $03909aa8b5a3673a$var$API,
    getBarStatus: $03909aa8b5a3673a$var$getBarStatus,
    stars: $03909aa8b5a3673a$var$stars,
    addRating: $03909aa8b5a3673a$var$addRating,
    getRating: $03909aa8b5a3673a$var$getRating,
    setMaps: $03909aa8b5a3673a$var$setMaps,
    refreshMaps: $03909aa8b5a3673a$var$refreshMaps,
    setRatings: $03909aa8b5a3673a$var$setRatings,
    setStatuses: $03909aa8b5a3673a$var$setStatuses
});

});

parcelRegister("5xoiS", function(module, exports) {
(function($) {
    function setActiveFilter() {
        var links = $('.filter-row-left .filter-btn[href], .filter-row-left .filter-dropdown-item[href]');
        if (links.length === 0) return;
        var current = window.location.pathname.replace(/index\.html$/, '') || '/';
        links.each(function() {
            var link = $(this);
            var linkPath = new URL(link.attr('href'), window.location.origin).pathname.replace(/index\.html$/, '') || '/';
            var isHome = current === '/' && linkPath === '/pubs/';
            var isPaginated = linkPath === '/pubs/' && current.indexOf('/pubs/') === 0;
            link.toggleClass('is-active', linkPath === current || isHome || isPaginated);
        });
        $('#filter-more-toggle').toggleClass('is-active', $('.filter-dropdown-menu .is-active').length > 0);
    }
    function setFilterDropdown() {
        var dropdown = $('#filter-more');
        if (dropdown.length === 0) return;
        var toggle = dropdown.find('#filter-more-toggle');
        toggle.on('click', function(e) {
            e.stopPropagation();
            var isOpen = dropdown.toggleClass('is-open').hasClass('is-open');
            toggle.attr('aria-expanded', isOpen);
        });
        $(document).on('click', function(e) {
            if (!$(e.target).closest(dropdown).length) {
                dropdown.removeClass('is-open');
                toggle.attr('aria-expanded', false);
            }
        });
        $(document).on('keydown', function(e) {
            if (e.key === 'Escape') {
                dropdown.removeClass('is-open');
                toggle.attr('aria-expanded', false);
            }
        });
    }
    window.mypubs.setRatings();
    window.mypubs.setStatuses();
    window.mypubs.setMaps();
    setActiveFilter();
    setFilterDropdown();
})(jQuery);

});

parcelRequire("iYusr");
parcelRequire("5xoiS");
(function($) {
    function showOpen() {
        $('article').each(function() {
            var status = $(this).find('.bar-hours');
            if (status.length > 0) {
                var info = window.mypubs.getBarStatus(status);
                if (!info.isOpen) $(this).addClass('hidden');
            }
        });
        $('#bars-list').removeClass('hidden');
        $('.items-loading').hide();
        window.mypubs.refreshMaps();
    }
    async function applyRatingFilter(article, value) {
        article.toggleClass('hidden', isNaN(value) || value < 4.5);
    }
    function reveal() {
        sortByRating();
        $('#bars-list').removeClass('hidden');
        $('.items-loading').hide();
        window.mypubs.refreshMaps();
    }
    function sortByRating() {
        var container = $('#bars-list');
        container.find('article').sort(function(a, b) {
            var ratingA = parseFloat($(a).find('.bar-rating').attr('value'));
            var ratingB = parseFloat($(b).find('.bar-rating').attr('value'));
            if (isNaN(ratingA)) ratingA = 0;
            if (isNaN(ratingB)) ratingB = 0;
            return ratingB - ratingA;
        }).appendTo(container);
    }
    async function showWithRating() {
        var pending = 0;
        $('article').each(function() {
            var article = $(this);
            var rating = article.find('.bar-rating');
            if (rating.length === 0) return;
            var value = parseFloat(rating.attr('value'));
            if (!isNaN(value)) {
                applyRatingFilter(article, value);
                return;
            }
            pending += 1;
            var observer = new MutationObserver(function() {
                var updated = parseFloat(rating.attr('value'));
                if (isNaN(updated)) return;
                observer.disconnect();
                applyRatingFilter(article, updated);
                pending -= 1;
                if (pending === 0) reveal();
            });
            observer.observe(rating[0], {
                attributes: true,
                attributeFilter: [
                    'value'
                ]
            });
        });
        if (pending === 0) reveal();
    }
    if (window.location.pathname.endsWith('open.html')) showOpen();
    if (window.location.pathname.endsWith('rating.html')) showWithRating();
})(jQuery);




//# sourceMappingURL=filtered-module.93e1830e.js.map
